import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { IonButton, IonIcon } from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomButton',
  props: {
	class: { type: String },
	fill: { type: String as () => 'default' | 'clear' | 'outline' | 'solid', default: 'solid' },
	iconLeft: { type: String },
	iconRight: { type: String },
	text: { type: String as () => string, default: '' },
	color: { type: String, default: '' },
},
  emits: ['onClick'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onClick = async () => {
	emit('onClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    color: props.color || 'primary',
    class: _normalizeClass(["flex justify-between items-center w-full normal-case text-base text-anykrowd-dark", props.class]),
    fill: props.fill,
    shape: "round",
    onClick: onClick
  }, {
    default: _withCtx(() => [
      (props.iconLeft)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 0,
            icon: props.iconLeft,
            class: _normalizeClass(["mr-2", [props.color ? `text-${props.color}` : props.fill === 'outline' ? 'text-white' : 'text-anykrowd-dark']])
          }, null, 8, ["icon", "class"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(["justify-start font-sourcesanspro-semibold", props.color ? `text-${props.color}` : ''])
      }, _toDisplayString(_ctx.$t(props.text)), 3),
      (props.iconRight)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 1,
            icon: props.iconRight
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["color", "class", "fill"]))
}
}

})